import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';

interface IUpdateGroupParams {
  title: string;
  landingPageDesigns?: number[];
}

const editLandingPageDesignGroup = async (
  groupId: number,
  data: IUpdateGroupParams
) => {
  return await EXPRESS_API.put(
    `/superadmin/landing-page-design-groups/${groupId}`,
    data
  );
};

export const useEditGroupMutation = (
  groupId: number,
  onSuccess?: () => void
) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(
    (params: IUpdateGroupParams) => editLandingPageDesignGroup(groupId, params),
    {
      onSuccess: async () => {
        successToast({
          title: 'Group has been successfully edited!',
        });
        await queryClient.refetchQueries({
          queryKey: 'LANDING_PAGE_DESIGN_GROUPS',
          exact: false,
        });
        await queryClient.refetchQueries({
          queryKey: 'LANDING_PAGE_DESIGN_GROUP',
          exact: false,
        });
        if (onSuccess) onSuccess();
      },
      onError: error => {
        showError(error || 'An error occured while trying to edit the group!');
      },
    }
  );
};
